<template>
  <v-dialog v-model="dialog" persistent max-width="1600px">
    <v-form ref="form" v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline">Bod</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row dense>
              <v-col cols="4">
                <v-text-field
                  label="IDMB"
                  v-model="bod.IDMB"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="IDMBP"
                  type="number"
                  v-model.number="bod.IDMBP"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="ZNMB"
                  v-model="bod.ZNMB"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="X"
                  type="number"
                  v-model.number="bod.X"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Y"
                  type="number"
                  v-model.number="bod.Y"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  label="Z"
                  type="number"
                  v-model.number="bod.Z"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <date-picker
                  v-model="bod.DatumOd"
                  label="Dátum od"
                  name="datumOd"
                ></date-picker>
              </v-col>
              <v-col cols="4">
                <date-picker
                  v-model="bod.DatumDo"
                  label="Dátum do"
                  name="datumDo"
                ></date-picker>
              </v-col>
              <v-col cols="4">
                <v-checkbox
                  v-model="bod.Zobrazovat"
                  label="Zobrazovať na verejnej časti"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="Poznámka"
                  v-model="bod.Poznamka"
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="alert" text @click="deleteBod()">Vymazať</v-btn>
          <v-btn color="primary" text @click="dialog = false">Zavrieť</v-btn>
          <v-btn color="primary" text @click="save()">Uložiť</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import DatePicker from "../components/DatePicker.vue"
import * as Miscella from "../plugins/miscella.js"

export default {
  name: "BodDetail",
  components: {
    DatePicker
  },
  data: () => ({
    dialog: false,
    bod: {},
    oldid: "",
    valid: true,
    idRules: [v => (v && v.length === 3) || "ID musí mať tri znaky"]
  }),

  methods: {
    show: function(b) {
      this.dialog = true
      this.bod = Miscella.deepCloneObject(b)
      this.oldid = b.ID
      console.log("EDIT BOD", b)
    },

    async save() {
      if (this.$refs.form.validate()) {
        try {
          console.log("SAVE BOD", this.bod)
          let response = await this.$axios.post("/r/bod", {
            oldID: this.oldid,
            bod: this.bod
          })
          if (response.status === 200) {
            this.$store.commit("message", "Bod uložený")
            this.dialog = false
            this.$emit("change")
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      } else {
        this.$store.commit("alert", "Vo formulári sú chyby")
      }
    },

    async deleteBod() {
      if (confirm("Naozaj vymazať bod z databázy ?")) {
        try {
          let response = await this.$axios.delete("/r/bod/" + this.bod.ID)
          if (response.status === 200) {
            this.$store.commit("message", "Bod je vymazaný.")
            this.dialog = false
            this.$emit("change")
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      }
    }
  }
}
</script>
